import { memo } from 'react';
import OrderProductGroupHeader from '../OrderProductGroupHeader/OrderProductGroupHeader';
import OrderProductGroupTitle from '../OrderProductGroupTitle';
import OrderProductParentGroupPortal from './components/OrderProductParentGroupPortal';
import useOrderProductSectionHeader from './hooks/useOrderProductSectionHeader';
import { OrderProductSectionHeaderProps } from './orderProductSectionHeader.types';

const OrderProductSectionHeader = ({
  sections,
  sectionIndex,
  viewMode,
  canEditOrder,
  selectedItems,
  syncAndToggleItems,
}: OrderProductSectionHeaderProps) => {
  const {
    section,
    totals,
    selection,
    parentGroup,
    isGroupSection,
    isSectionExpanded,
    isSubGroupVisible,
    isParentGroupInline,
    bulkToggle,
    toggleGroup,
  } = useOrderProductSectionHeader({ sections, sectionIndex, selectedItems });

  const hasProductsInSection = !!section?.products.length;

  if (!isGroupSection || !hasProductsInSection) {
    return null;
  }

  const canSelect = canEditOrder && viewMode !== 'VIEW';

  const parentGroupSelection =
    canSelect && parentGroup
      ? {
          isSelected: parentGroup.selection.isSelected,
          isIndeterminate: parentGroup.selection.isIndeterminate,
          onToggle: () => syncAndToggleItems(parentGroup.selection.keys),
        }
      : undefined;

  const sectionSelection = canSelect
    ? {
        isSelected: selection.isSelected,
        isIndeterminate: selection.isIndeterminate,
        onToggle: () => syncAndToggleItems(selection.keys),
      }
    : undefined;

  return (
    <>
      {parentGroup && (
        <OrderProductParentGroupPortal container={parentGroup.container}>
          <OrderProductGroupHeader
            variant={isSubGroupVisible ? 'parentGroup' : 'section'}
            totals={parentGroup.totals}
            isExpanded={parentGroup.isExpanded}
            selection={parentGroupSelection}
            bulkToggle={parentGroup.bulkToggle}
            title={<OrderProductGroupTitle section={section} variant="parentGroup" />}
            onToggleExpanded={parentGroup.toggleExpanded}
          />
        </OrderProductParentGroupPortal>
      )}

      {isSubGroupVisible && (
        <OrderProductGroupHeader
          totals={totals}
          isExpanded={isSectionExpanded}
          variant={section.parentGroupKey ? 'subGroup' : 'section'}
          hasTopSpacing={!isParentGroupInline}
          selection={sectionSelection}
          bulkToggle={bulkToggle}
          title={<OrderProductGroupTitle section={section} />}
          onToggleExpanded={toggleGroup}
        />
      )}
    </>
  );
};

export default memo(OrderProductSectionHeader);
